/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useState, useCallback, useEffect, useContext,
    useRef,
} from 'react';
import { ThreeDots } from 'react-loader-spinner';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../../Components/Context/HeaderContext';
import CreditDebitListing from './CreditDebitListing';
import CreditDebitListSkeleton from './listSkeleton';
import Pagination from '../../Components/Pagination';
import FilterModal from './Modals/filterModal';
import EmptyOrderPage from '../MyOrders/EmptyOrderPage';

function ManageCreditDebitDetails() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [creditDebitList, setCreditDebitList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [emptyData, setEmptyData] = useState(false);
    const [totalPage, setTotalPage] = useState('');
    const [totalResult, setTotalResult] = useState(0);
    const [successStatus, setSuccessStatus] = useState(false);
    const [sortType, setsortType] = useState('AR_DATE+desc');
    const [searchValue, setsearchValue] = useState('');
    const [filterValue, setfilterValue] = useState('');
    const [filterModal, setFilterModal] = useState(false);
    const [Filter, setFilter] = useState({
        transaction_type: [],
        date_range: [],
        org_code: [],
    });
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [exportLoading, setExportLoading] = useState(null);

    const handleFetchCreditDebitDetails = useCallback((page, search, filter) => {
        setLoading(true);
        distributorService.CreditDebitDetailsList(page, search, filter).then((resp) => {
            if (resp?.error === false && resp?.data?.success_status) {
                if (resp?.data?.data?.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setCreditDebitList(resp?.data?.data);
                setCurrentPage(resp?.data?.current_page);
                setTotalPage(resp?.data?.number_of_pages);
                setTotalResult(resp?.data?.total_result || 0);
                setSuccessStatus(resp?.data?.success_status);
            } else {
                setLoading(false);
                setSuccessStatus(false);
            }
        }).catch((error) => {
            setLoading(false);
            setSuccessStatus(false);
        });
    }, []);

    const handlePageClick = async (data) => {
        setLoading(true);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };
    const buttonRef = useRef(null);

    useEffect(() => {
        if (!exportClick) return;

        // Function to handle clicks outside the button
        function handleClickOutside(event) {
            if (buttonRef.current && !buttonRef.current.contains(event.target)) {
                setexportClick(false);
            }
        }

        // Add event listener with a small delay to allow the dropdown to render first
        const timeoutId = setTimeout(() => {
            document.addEventListener('mousedown', handleClickOutside);
        }, 10);

        // Cleanup the event listener when the component is unmounted or exportClick changes
        return () => {
            clearTimeout(timeoutId);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [exportClick]);

    function isExceedingSixMonths(date1, date2) {
        const startDate = new Date(date1);
        const endDate = new Date(date2);

        // Calculate the total days difference
        const daysDiff = (endDate - startDate) / (1000 * 60 * 60 * 24);

        // If the difference exceeds 183 days (approximately 6 months), return true
        return daysDiff > 183;
    }
    const showExport = () => {
        // Validate that date range has been applied via filter (not just selected in modal)
        if (!filterValue.includes('date_range')) {
            SetErrorMessage('Please select and apply a date range filter');
            setcolorValue('warning');
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        // Validate dates are present (should be present if filter is applied)
        if (!selected?.start_date || !selected?.end_date) {
            SetErrorMessage('Please select a date range');
            setcolorValue('warning');
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        if (isExceedingSixMonths(selected?.start_date, selected?.end_date)) {
            SetErrorMessage('Date range should not exceed 6 months');
            setcolorValue(true);
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        // Only open dropdown if validation passes
        setexportClick(!exportClick);
    };
    const handleExport = useCallback((exportType) => {
        // Validate that date range has been applied via filter (not just selected in modal)
        if (!filterValue.includes('date_range')) {
            SetErrorMessage('Please select and apply a date range filter');
            setcolorValue('warning');
            setexportSelected(''); // Reset exportSelected to prevent auto-triggering
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        // Validate dates are present (should be present if filter is applied)
        if (!selected?.start_date || !selected?.end_date) {
            SetErrorMessage('Please select a date range');
            setcolorValue('warning');
            setexportSelected(''); // Reset exportSelected to prevent auto-triggering
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        if (isExceedingSixMonths(selected?.start_date, selected?.end_date)) {
            SetErrorMessage('Date range should not exceed 6 months');
            setcolorValue(true);
            setexportSelected(''); // Reset exportSelected to prevent auto-triggering
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        setExportLoading(exportType);
        distributorService.ExportCreditDebitDetails(exportType, selected, filterValue, searchValue).then((val) => {
            if (val.error === false && val.data.success_status) {
                SetSuccessMessage(val.data.message || 'Export initiated successfully');
                setcolorValue(false);
                setexportClick(false);
                setexportSelected('');
                setExportLoading(null);
                if (val.data.url) {
                    window.open(val.data.url, '_blank');
                }
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 3000);
            } else {
                SetErrorMessage(val.data?.message || 'Export failed. Please try again.');
                setcolorValue(true);
                setexportSelected(''); // Reset exportSelected on error
                setExportLoading(null);
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue(false);
                }, 3000);
            }
        }).catch((error) => {
            SetErrorMessage('Export failed. Please try again.');
            setcolorValue(true);
            setexportSelected(''); // Reset exportSelected on error
            setExportLoading(null);
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 3000);
        });
    }, [selected, filterValue, searchValue, SetErrorMessage, SetSuccessMessage, setcolorValue]);

    useEffect(() => {
        // Only trigger export when exportSelected changes and is not empty
        if (exportSelected !== '') {
            handleExport(exportSelected);
        }
    }, [exportSelected, handleExport]);

    useEffect(() => {
        handleFetchCreditDebitDetails(currentPage, searchValue, filterValue);
    }, [currentPage, searchValue, filterValue, handleFetchCreditDebitDetails]);


    return (
        <div className="md:px-[46px] px-4 sm:pt-[30px] pt-3.5">
            <div className="flex justify-between items-center flex-wrap pb-[10px]">
                <h5 className="sm:text-xs10 text-lg font-semibold text-[#090406] lg:mb-0 mb-3">Credit/Debit Details</h5>
                <div className="lg:mb-0 mb-3">
                    <div className="flex sm:mx-2 mx-0 items-center flex-wrap w-full">
                        <button
                            type="button"
                            className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                            style={{
                                border: '2px solid #E9EDF4',
                            }}
                            data-testid="filter-btn"
                            data-bs-toggle="modal"
                            data-bs-target="#filtermodal"
                            onClick={() => setFilterModal(true)}
                        >
                            Filter
                        </button>
                        <div className="relative mr-2">
                            <label htmlFor="search" />
                            <input
                                type="text"
                                name="search"
                                id="search"
                                className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                                placeholder="Search"
                                value={searchValue}
                                onChange={(e) => {
                                    setsearchValue(e.target.value);
                                    setCurrentPage(1);
                                }}
                                autoComplete="off"
                            />
                            <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                        </div>
                        <div className="pl-2 dropdown relative" ref={buttonRef}>
                            <button
                                type="button"
                                id="exportDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                data-testid="export-btn"
                                disabled={loading || creditDebitList.length === 0}
                                className={`dropdown-toggle text-xs2 font-semibold text-[#555259] sm:py-2.5 py-1.5 sm:px-4 px-2 border border-[#555259] rounded-lg flex items-center justify-center min-w-[140px] ${
                                    loading || creditDebitList.length === 0
                                        ? 'text-[#A0A0A0] border-[#E0E0E0] cursor-not-allowed opacity-60'
                                        : ''
                                }`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (!loading && creditDebitList.length > 0) {
                                        showExport();
                                    }
                                }}
                            >
                                {exportLoading ? (
                                    <ThreeDots 
                                        width={30} 
                                        height={24} 
                                        wrapperStyle={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                    />
                                ) : 'Generate Report'}
                            </button>
                            <ul className={`dropdown-menu sm:min-w-[125px] min-w-[120px] ${exportClick === true ? 'show' : 'hidden'} absolute top-full left-1/2 -translate-x-1/2 mt-1 bg-[#FFFFFF] rounded-lg shadow-s2 z-[9] sm:p-3.5 p-1.5`} style={{zIndex: '9'}} aria-labelledby="exportDropdown" onClick={(e) => e.stopPropagation()}>
                                <li className={`sm:py-1 py-0.5 export border-b border-[#D8D8D8] ${exportLoading || loading || creditDebitList.length === 0 ? 'opacity-60 cursor-not-allowed' : 'hover:bg-[#F2F2F3] hover:rounded'}`}>
                                    <a
                                        className={`dropdown-item sm:text-xs5 text-sm font-normal w-full inline-block px-1.5 py-0.5 text-center ${
                                            exportLoading || loading || creditDebitList.length === 0
                                                ? 'text-[#A0A0A0] cursor-not-allowed pointer-events-none'
                                                : 'text-[#555259] cursor-pointer'
                                        }`}
                                        href="#"
                                        data-testid="csv-btn"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (!exportLoading && !loading && creditDebitList.length > 0) {
                                                setexportSelected('csv');
                                            }
                                        }}
                                    >
                                        CSV
                                    </a>
                                </li>
                                <li className={`sm:py-1 py-0.5 border-b border-[#D8D8D8] ${exportLoading || loading || creditDebitList.length === 0 ? 'opacity-60 cursor-not-allowed' : 'hover:bg-[#F2F2F3] hover:rounded'}`}>
                                    <a
                                        className={`dropdown-item sm:text-xs5 text-sm font-normal w-full inline-block px-1.5 py-0.5 text-center ${
                                            exportLoading || loading || creditDebitList.length === 0
                                                ? 'text-[#A0A0A0] cursor-not-allowed pointer-events-none'
                                                : 'text-[#555259] cursor-pointer'
                                        }`}
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (!exportLoading && !loading && creditDebitList.length > 0) {
                                                setexportSelected('pdf');
                                            }
                                        }}
                                        data-testid="pdf-btn"
                                    >
                                        PDF
                                    </a>
                                </li>
                                <li className={`sm:py-1 py-0.5 ${exportLoading || loading || creditDebitList.length === 0 ? 'opacity-60 cursor-not-allowed' : 'hover:bg-[#F2F2F3] hover:rounded'}`}>
                                    <a
                                        className={`dropdown-item sm:text-xs5 text-sm font-normal w-full inline-block px-1.5 py-0.5 text-center ${
                                            exportLoading || loading || creditDebitList.length === 0
                                                ? 'text-[#A0A0A0] cursor-not-allowed pointer-events-none'
                                                : 'text-[#555259] cursor-pointer'
                                        }`}
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (!exportLoading && !loading && creditDebitList.length > 0) {
                                                setexportSelected('xlsx');
                                            }
                                        }}
                                        data-testid="excel-btn"
                                    >
                                        Excel
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {loading ? <CreditDebitListSkeleton />
                : (
                    <div>
                        {creditDebitList.length > 0 && (
                            <CreditDebitListing
                                creditDebitList={creditDebitList}
                            />
                        )}
                        {creditDebitList.length > 0 && totalResult > 10 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                List={creditDebitList}
                                currentPage={currentPage}
                                totalPage={totalPage}
                                loading={loading}
                            />
                        )}
                        {filterModal && (
                            <FilterModal
                                filterModal={filterModal}
                                setFilterModal={setFilterModal}
                                Filter={Filter}
                                setFilter={setFilter}
                                filterValue={filterValue}
                                setfilterValue={setfilterValue}
                                handleFilter={handleFilter}
                                handleFetchCreditDebitDetails={handleFetchCreditDebitDetails}
                                selected={selected}
                                setselected={setselected}
                                SetSuccessMessage={SetSuccessMessage}
                            />
                        )}
                        {emptyData && (
                            <EmptyOrderPage
                                search="yes"
                                text="no Credit/Debit Details"
                                buttonRequired={false}
                                all={searchValue.length > 0 ? 'under searched term' : 'found'}
                            />
                        )}
                    </div>
                )}
        </div>
    );
}

export default ManageCreditDebitDetails;

